// @owners { team: patients }
import { COLORS, SIZES } from '@alto/design-library-tokens';
import {
  ActionSheetContext,
  Body,
  Button,
  Card,
  Column,
  LgPadding,
  MdSpacing,
  Row,
  SizedImage,
  Tag,
  XsSpacing,
} from '@alto/design-system';
import { Pill, RenewalRequestActionSheet } from '@alto/features';
import React, { useContext } from 'react';
import { formatQuantity } from '~shared/helpers/helper';
import { type Prescription } from '~shared/types';

type Props = {
  prescriptions: Prescription[];
};

export const LastRefillCard = ({ prescriptions }: Props) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);

  return (
    <Card
      title="Last refill"
      description="Request more so you don't run out"
    >
      <LgPadding>
        {prescriptions.map((prescription) => {
          return (
            <Row key={prescription.id}>
              <Column flexShrink={1}>
                {prescription.image_url ? (
                  <SizedImage
                    // @ts-expect-error - image url type is string and is valid source type
                    source={prescription.image_url}
                    pixelSize={SIZES.ILLUSTRATION.SM.value}
                    maxHeight={SIZES.ILLUSTRATION.SM.value}
                  />
                ) : (
                  <Pill />
                )}
              </Column>
              <XsSpacing />
              <Column>
                <Body
                  fontFamily="bold"
                  color={COLORS.TEXT_COLORS.PRIMARY}
                >
                  {prescription.medication_name}
                </Body>
                <Body textSize="detail">{formatQuantity(prescription)}</Body>
                <XsSpacing />
                {prescription.active_renewal_request_start_at ? (
                  <Tag label="Refills requested" />
                ) : (
                  <Button
                    type="primary"
                    width="inline"
                    onPress={() => {
                      setActiveActionSheet(<RenewalRequestActionSheet prescriptionIDs={[prescription.id]} />);
                    }}
                    small
                  >
                    Get more refills
                  </Button>
                )}
                <MdSpacing />
              </Column>
            </Row>
          );
        })}
      </LgPadding>
    </Card>
  );
};
